import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/AdminLayout.vue'
import { getDefaultRoute } from '@/config/menu'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/knowledge',
    children: [
      { path: 'knowledge', name: 'KnowledgeList', component: () => import('@/views/knowledge/List.vue'), meta: { title: '知识库列表', roles: ['admin', 'creator'] } },
      { path: 'knowledge/edit/:id', name: 'KnowledgeEdit', component: () => import('@/views/knowledge/Edit.vue'), meta: { title: '编辑知识条目', roles: ['admin', 'creator'] } },
      { path: 'upload', name: 'Upload', component: () => import('@/views/Upload.vue'), meta: { title: '文档上传（自动格式转换）', roles: ['admin', 'creator'] } },
      { path: 'preset', name: 'Preset', component: () => import('@/views/Preset.vue'), meta: { title: '系统预设（FAQ 常问问题）', roles: ['admin', 'creator'] } },
      { path: 'feedback', name: 'Feedback', component: () => import('@/views/Feedback.vue'), meta: { title: '用户反馈收集', roles: ['admin', 'creator'] } },
      { path: 'password', name: 'ChangePassword', component: () => import('@/views/ChangePassword.vue'), meta: { title: '修改密码', roles: ['admin', 'creator'] } },
      { path: 'accounts', name: 'Accounts', component: () => import('@/views/Accounts.vue'), meta: { title: '账号管理', roles: ['admin'] } },
      { path: 'exam/questions', name: 'ExamQuestions', component: () => import('@/views/exam/QuestionBank.vue'), meta: { title: '题库管理', roles: ['admin', 'creator'] } },
      { path: 'exam/manage', name: 'ExamManage', component: () => import('@/views/exam/ExamManage.vue'), meta: { title: '试卷管理（组卷 / 发布）', roles: ['admin', 'creator'] } },
      { path: 'exam/grading', name: 'ExamGrading', component: () => import('@/views/exam/Grading.vue'), meta: { title: '阅卷中心', roles: ['admin', 'creator'], hidden: true } },
      { path: 'exam/ranking', name: 'ExamRanking', component: () => import('@/views/exam/Ranking.vue'), meta: { title: '成绩管理', roles: ['admin', 'creator'] } },
      { path: 'exam/my-exams', name: 'MyExams', component: () => import('@/views/exam/MyExams.vue'), meta: { title: '我的考试', roles: ['examinee'] } },
      { path: 'exam/my-scores', name: 'MyScores', component: () => import('@/views/exam/MyScores.vue'), meta: { title: '我的成绩', roles: ['examinee'] } },
      { path: 'exam/take/:recordId', name: 'TakeExam', component: () => import('@/views/exam/TakeExam.vue'), meta: { title: '在线答题', roles: ['examinee'] } },
      { path: 'exam/complete/:recordId', name: 'ExamComplete', component: () => import('@/views/exam/ExamComplete.vue'), meta: { title: '交卷成功', roles: ['examinee'] } },
      { path: 'exam/result/:recordId', name: 'ExamResult', component: () => import('@/views/exam/ExamResult.vue'), meta: { title: '考试结果', roles: ['examinee'] } }
    ]
  }
]

const router = new VueRouter({ mode: 'hash', routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('faq_admin_token')
  if (!to.meta.public && !token) {
    next('/login')
    return
  }
  if (to.meta.roles) {
    const user = JSON.parse(localStorage.getItem('faq_admin_user') || '{}')
    if (!to.meta.roles.includes(user.role)) {
      next(getDefaultRoute(user.role))
      return
    }
  }
  next()
})

export default router
